"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPageId = void 0;
const crypto = __importStar(require("crypto"));
const createPageId = (layout) => {
    const idList = getIds(layout);
    const generateId = () => {
        const generatedId = generateRandomId();
        if (idList.includes(generatedId)) {
            return generateId();
        }
        return generatedId;
    };
    const generatedId = generateId();
    return generatedId;
};
exports.createPageId = createPageId;
const generateRandomId = (length = 10) => {
    const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const result = Array.from(crypto.randomBytes(length))
        .map((byte) => charset[byte % charset.length])
        .join("");
    return result;
};
const getIds = (layout) => {
    const ids = [];
    // page 별로 순회하며 page의 Id와 Section 내부의 Id를 조회
    layout.forEach((page) => {
        ids.push(page.id);
        ids.push(page.section.id);
        const nodeIds = collectNodeIds(page.section.node);
        ids.push(...nodeIds);
    });
    return ids;
};
const collectNodeIds = (nodes) => {
    const nodeIds = [];
    const collectId = (node) => {
        // node의 id를 추가
        const nodeId = node.id;
        nodeIds.push(nodeId);
        if (node.type === "flex") {
            const baseFlexContent = node;
            if (baseFlexContent.node && baseFlexContent.node.length > 0) {
                const innerNodeIds = collectNodeIds(baseFlexContent.node); // Recursively collect ids from nested nodes
                nodeIds.push(...innerNodeIds);
            }
        }
    };
    /**
     *  BaseFlexContent를 extends하고 있는 node는 nodes를 배열로 가진다
     *  type이 flex인 경우에는 한 depth 더 깊은 위치에 node 배열이 있을 수 있다
     *  (type이 flex가 아니라면 elements)
     *  내부 node id들을 재귀적으로 순회하여 조회한다
     */
    nodes.forEach((node) => collectId(node));
    return nodeIds;
};
